<template>
  <div id="mess">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="content">
      <div class="confirm">
        <div class="icon">
          <i class="iconfont">&#xe6c0;</i>
        </div>
        <div>
          <p>订单待确认</p>
          <p class="cue">请您确认订单金额</p>
        </div>
      </div>
      <div class="message">
        <p>----基本信息----</p>
        <p class="message-title border-bottom">配送方式<span>用户自提</span></p>
        <p class="message-title">支付方式<span>在线付款</span></p>
      </div>
      <div v-for="item in list" :key="item.id">
        <div>
          <div class="shop">
            <i class="iconfont">&#xe624;</i>
            <h5>{{item.shop_name}}</h5>
          </div>
          <div class="order-message" v-for="gitem in item.goodsList" :key="gitem.pro_id">
            <div class="order_img">
              <img :src="gitem.img ? url + gitem.img : defaultimg">
            </div>
            <div class="order_info">
              <div>
                <p class="title">{{gitem.title}}</p>
                <p class="spec">{{gitem.spec}}</p>
              </div>
              <div class="order-price">
                <p>￥{{gitem.price}}</p>
                <p class="num">x{{gitem.num}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="pay">
          <p>应付金额<span>￥{{item.totalprice}}</span></p>
        </div>
      </div>
    </div>
    <div class="foot">
      <button type="submit" name="submit" :class="state === true ? 'allow' : 'forbid'" @click="handleSubmitClick">提交订单</button>
    </div>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'ConfirmMess',
  props: {
    list: Array,
    state: Boolean
  },
  data () {
    return {
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleSubmitClick () {
      this.axios.get('/ApiOrderConfirm/AddOrder', {
        params: {
          Type: decodeURIComponent(this.$route.query.Type),
          goodid: decodeURIComponent(this.$route.query.goodid),
          BuyCount: decodeURIComponent(this.$route.query.buycount),
          cartids: decodeURIComponent([this.$route.query.cartids])
        }
      }).then(this.handleSubSuccInfo)
        .catch(this.handleSubFailInfo)
    },
    handleSubSuccInfo (res) {
      res = res.data
      if (res.errorInfo === '') {
        // console.log(res.data.orderids)
        this.$router.push({
          path: '/pay',
          query: {
            Type: this.$route.query.Type,
            orderids: [res.data.orderids],
            ids: [res.data.ids]
          }
        })
      } else {
        alert(res.errorInfo)
      }
    },
    handleSubFailInfo (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 13px;}
.header .iconfont{ font-size: 25px;}
.header a{ text-decoration: none;}
.confirm{ text-align: center; background-color: #fff; padding: 15px 0; border-bottom: 5px solid #f2f2f2;}
.confirm .iconfont{ font-size: 30px; color: #fff; line-height: 55px;}
.confirm p{font-size: 14px; color: #202020;}
.confirm .cue{ font-size: 12px; color: #bbbbbb;}
.icon{ width: 55px; height: 55px; background-color: #6dc651; border-radius: 50%; margin-right: auto; margin-left: auto; margin-bottom: 5px;}
.message p{ text-align: center; font-size: 14px; color: #434343; margin-bottom: 10px;}
.message p span{ color: #a3a3a3;}
.message .message-title{ display: flex; justify-content: space-between; font-size: 14px; padding: 5px 0; margin-bottom: 0;}
.message{ background-color: #fff; padding: 10px 15px; border-bottom: 5px solid #f2f2f2; padding-bottom: 3px;}
.pay{ background-color: #fff; height: 45px; padding: 0 15px; font-size: 14px; border-bottom: 5px solid #f2f2f2;}
.content{ background-color: #fff; border-top: 10px solid #eff3f6;}
.order-message{ display: flex; justify-content: flex-start; font-size: 14px;}
.order-message{ padding: 10px 15px; background-color: #f2f2f2; margin-bottom: 5px;}
.order-message img{ margin-right: 11px; width: 80px; height: 80px;}
.spec{ color: #949494; margin-top: 5px;}
.num{ color: #434343; float: right;}
.order-price{ overflow: hidden; padding-top: 5px;}
.order-price p:first-child{ float: left; color: #ff0135;}
.shop{ padding: 10px 15px; padding-right: 0; display: flex; align-items: center;}
.shop h5{ font-size: 14px; color: #434343; font-family: Arial,Microsoft YaHei;}
.shop .iconfont{ margin-right: 5px;}
.pay p{ line-height: 45px; color: #434343; display: flex; justify-content: space-between;}
.pay span{ color: #ff0135; font-weight: bold;}
.title{ word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;}
.foot{ margin: 15px 0;}
.foot button{ border: 0; color: #fff; width: 90%; height: 40px; display: block; margin-left: auto; margin-right: auto; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.allow{ background-color: #fe2a29;}
.forbid{ background: #ccc;}
.order_img{ width: 27%;}
.order_info{ width: 73%;}
</style>



// WEBPACK FOOTER //
// src/pages/confirm/components/Mess.vue